const normalizeError = error => {
  if (error?.response) {
    return (
      error?.response?.data?.[0]?.solucao ||
      error?.response?.data?.solucao ||
      error?.response?.data?.message ||
      'Ocorreu um erro na sua solicitação'
    );
  }

  return error?.message;
};

export default normalizeError;
